import { hasAuthParams } from 'react-oidc-context';

import { getPrivateClaims } from '../api/govbr';
import { getLinkedCompanies } from '../api/govbr';
import { existeCpf } from './govbr';
import { extraiCpf } from './govbr';
import { isAdminProfile } from './profile';
import { clearOidcInformation, loadComplianceRoles } from './oidc';

export const recuperaInformacoesDoUsuario = function (auth) {
  const profile = auth.user?.profile;
  const accessToken = auth.user?.access_token;
  if (profile && accessToken) {
    if (isAdminProfile()) {
      return recuperaInformacoesPmpa(profile);
    } else {
      return recuperaInformacoesGovBr(profile, accessToken);
    }
  }
}

export const verificaRolesAdmin = function (auth) {
  const profile = auth.user?.profile;
  const accessToken = auth.user?.access_token;
  if (profile && accessToken) {
    if (isAdminProfile()) {
      return loadComplianceRoles();
    } else {
      return null;
    }
  }
}

const recuperaInformacoesPmpa = function (profile) {
  return new Promise((resolve, reject) => {
    if (profile) {
      resolve({ nomeCompleto: profile.name, username: profile.preferred_username, cpf: '', cnpj: [] });
    } else {
      reject(null);
    }
  });
};

const recuperaInformacoesGovBr = function (profile, accessToken) {
  return (
    getPrivateClaims(accessToken)
      .then(privateClaimsResponseHandler.bind(null, profile, accessToken))
      .catch(errorHandler)
  );
}

const privateClaimsResponseHandler = function (profile, accessToken, privateClaims) {
  return new Promise((resolve, reject) => {
    if (existeCpf(privateClaims)) {
      const cpf = extraiCpf(privateClaims);
      getLinkedCompanies(cpf, accessToken)
        .then(cnpj => {
          if (cnpj) {
            const profileComCnpj = { ...profile, cpf, cnpj };
            resolve(profileComCnpj);
          } else {
            reject(null);
          }
        })
        .catch(errorHandler);
    } else {
      reject(null);
    }
  });
};

const errorHandler = function (error) {
  console.error(error);
  return Promise.reject(null);
};

export const logout = function (auth) {
  clearOidcInformation();
  auth.signoutRedirect();
}

export const redirecionaParaAutenticacao = function (auth) {
  auth.signinRedirect();
}

export const erroAutenticacao = function (auth) {
  return auth.error ? auth.error.message : null;
}

export const autenticacaoEmProcesso = function (auth) {
  return auth.activeNavigator ? 'Autenticação em processo...' : null;
}

export const deveRedirecionarParaAutenticacao = function (auth) {
  return !hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading;
}

export function isAutenticado(auth) {
  return auth.isAuthenticated;
}
